angular.module('impactx.checkboxgroup').directive('ixCheckboxGroup', function ($filter, $parse) {
    return {
        restrict: 'EA',
        require: 'ngModel',
        link: function (scope, element, attr, ngModel) {
            var minAmount = parseInt(attr.checkboxGroupMin);
            var maxAmount = parseInt(attr.checkboxGroupMax);
            var checkedItems = [];
            var checkedItemsCount = 0;
            var modelData = {};

            function checkValidation() {
                var freeTextInput = $parse(attr.checkboxGroupFreeTextInput)(scope);
                var freeTextInputEnabled = $parse(attr.checkboxGroupFreeTextInputEnabled)(scope);

                if (freeTextInputEnabled && freeTextInput && freeTextInput.value) {
                    const currentLabel = $parse(attr.checkboxGroupFreeTextLabel)(scope);
                    const hasLabel = !!(currentLabel && currentLabel.length > 0) ||
                        !!(freeTextInput.label && freeTextInput.label.length > 0);
                    ngModel.$setValidity('checkboxGroupFreetextLabel', hasLabel);
                } else {
                    ngModel.$setValidity('checkboxGroupFreetextLabel', true);
                }

                if (modelData && (minAmount || maxAmount)) {
                    checkedItems = $filter('filter')(modelData, {value: true});
                    checkedItemsCount = checkedItems.length;
                    if (freeTextInputEnabled && freeTextInput && freeTextInput.value) {
                        checkedItemsCount++;
                    }
                    if (minAmount) {
                        ngModel.$setValidity('checkboxGroupMin', checkedItemsCount >= minAmount);
                    }
                    if (maxAmount) {
                        ngModel.$setValidity('checkboxGroupMax', checkedItemsCount <= maxAmount);
                    }
                }
                else {
                    ngModel.$setValidity('checkboxGroupMin', true);
                    ngModel.$setValidity('checkboxGroupMax', true);
                }
            }

            scope.$watch(attr.ngModel, function (newModel) {
                modelData = newModel;
                checkValidation();
            }, true);

            scope.$watch(attr.checkboxGroupFreeTextInput, function () {
                checkValidation();
            }, true);
        }
    }
});